var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTournaments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 3h3.496c.552 0 1.003.448 1.004 1 .005 2.838-.196 5.45-4.5 5.923V10l-.008.309a6 6 0 01-5.242 5.642V20.5H16a.75.75 0 010 1.5H8a.75.75 0 010-1.5h3.25v-4.549a6 6 0 01-5.242-5.642L6 10v-.077C1.696 9.45 1.495 6.838 1.5 4c.001-.552.452-1 1.004-1H6V2h12v1zM7.5 10a4.5 4.5 0 009 0V3.5h-9V10zM3.004 4.5c.018 1.253.124 2.098.483 2.694.276.458.86 1.008 2.513 1.218V4.5H3.004zM18 8.412c1.652-.21 2.237-.76 2.513-1.218.358-.596.465-1.441.483-2.694H18v3.912z",
    fill: "currentColor"
  })));
}
SvgTournaments.displayName = 'Tournaments';
export default SvgTournaments;